import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Brain, Stethoscope, Check } from 'lucide-react';
const audiences = [{
  id: 1,
  icon: <BookOpen className="w-6 h-6 text-brand-lilac" data-id="element-221" />,
  title: 'Estudiantes de los primeros años',
  description: 'Arrancaste la carrera y la cantidad de lectura te abruma. Con PsiRecursos Pro vas a tener todo organizado para estudiar sin perder el hilo.',
  bullets: ['Planificadores semanales y por materia', 'Sistema para controlar tus lecturas']
}, {
  id: 2,
  icon: <Brain className="w-6 h-6 text-brand-lilac" data-id="element-222" />,
  title: 'Estudiantes en años intermedios',
  description: 'Estás en el medio de la carrera, con teóricos, prácticos y trabajos al mismo tiempo. Acá vas a encontrar el orden que necesitás para no hundirte.',
  bullets: ['Resúmenes de corrientes psicológicas', 'Mapas conceptuales y esquemas visuales']
}, {
  id: 3,
  icon: <Stethoscope className="w-6 h-6 text-brand-lilac" data-id="element-223" />,
  title: 'Estudiantes próximos a las prácticas clínicas',
  description: 'Estás por arrancar las prácticas y no sabés por dónde empezar. El material clínico te prepara para la primera entrevista y los casos reales.',
  bullets: ['Guías de entrevista y caso clínico', 'Plantillas de informe psicológico']
}];
export function TargetAudience() {
  return <section className="bg-brand-dark py-16 px-4 sm:px-6 lg:px-8" data-id="element-224">
      <div className="max-w-2xl mx-auto" data-id="element-225">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl sm:text-3xl font-bold text-center text-white mb-10" data-id="element-226">
          ¿Este sistema es para vos?
        </motion.h2>

        <div className="space-y-6" data-id="element-227">
          {audiences.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6" data-id="element-228">
              <div className="flex items-center gap-3 mb-4" data-id="element-229">
                <div className="p-2 bg-brand-violet/20 rounded-lg" data-id="element-230">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-white" data-id="element-231">{item.title}</h3>
              </div>

              <p className="text-gray-300 mb-5 text-[15px]" data-id="element-232">
                {item.description}
              </p>

              <ul className="space-y-2" data-id="element-233">
                {item.bullets.map((bullet, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-234">
                    <Check className="w-4 h-4 text-brand-sky mt-0.5 flex-shrink-0" data-id="element-235" />
                    <span data-id="element-236">{bullet}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}